import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavPanelState {
  public showChangeLocation$ = new BehaviorSubject<boolean>(true);
  public manualSelect$ = new BehaviorSubject<boolean>(false);

  constructor() {}
}
